var _path, _path2, _path3, _circle;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNotificationRed(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.9375 6.43994V9.76994",
    stroke: "#2C4657",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9564 2C9.27642 2 6.29642 4.98 6.29642 8.66V10.76C6.29642 11.44 6.01642 12.46 5.66642 13.04L4.39642 15.16C3.61642 16.47 4.15642 17.93 5.59642 18.41C10.3764 20 15.5464 20 20.3264 18.41C21.6764 17.96 22.2564 16.38 21.5264 15.16L20.2564 13.04C19.9064 12.46 19.6264 11.43 19.6264 10.76V8.66C19.6164 5 16.6164 2 12.9564 2Z",
    stroke: "#2C4657",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.2694 18.8198C16.2694 20.6498 14.7694 22.1498 12.9394 22.1498C12.0294 22.1498 11.1894 21.7698 10.5894 21.1698C9.98937 20.5698 9.60938 19.7298 9.60938 18.8198",
    stroke: "#2C4657",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20.4375,
    cy: 4.5,
    r: 4.5,
    fill: "#F0635A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationRed);
export default __webpack_public_path__ + "static/media/notification-red.c0e8b720b378116ffd6cec431099414e.svg";
export { ForwardRef as ReactComponent };